import { render } from "./OptionFiltering.vue?vue&type=template&id=77465ef8"
import script from "./OptionFiltering.vue?vue&type=script&lang=js"
export * from "./OptionFiltering.vue?vue&type=script&lang=js"
script.render = render

export default script